import StartTask from 'components/hyperdrive/createTask/StartTask';
import React from 'react';

export default function StartTaskDrawer({closeModal}) {
  return (
    <StartTask closeModal={closeModal}/>
  );
}
